import { BigNumber } from 'ethers';

import { Modes } from '@components/ModeSwitch';
import { PoolType } from '@config/base';

export type Mode = PoolType;

export const modes: Modes<Mode> = [
  { mode: 'MAIN', text: 'Main Pool' },
  { mode: 'VENO', text: 'Veno Pool' },
  { mode: 'DEFI', text: 'DeFi Pool' },
];

export type PartnerTokens =
  | 'MTD'
  | 'VVS'
  | 'FER'
  | 'LCRO'
  | 'LQTY'
  | 'ORB'
  | 'XARGO'
  | 'USC'
  | 'STARDUST';

export type RewardTokens = PartnerTokens | 'TONIC';

export interface NonTonicInfo {
  symbol: PartnerTokens;
  currentApy: number;
  rate: BigNumber;
}
